import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPound: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPound"><Path d="M14.75 7.29061C14.2132 6.80146 13.4789 6.5 12.6692 6.5C11.0245 6.5 9.69119 7.74365 9.69119 9.27778C9.69119 10.8119 11 12 11 12M14.5 16.5H9.0956L11 12M11 12H8.5M11 12H14.5M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPound;
